/** The sign of a served profit figure (S-6): what the case header, the money
 *  line, the board card and the list read to tone it.
 *
 *  A comparison, not arithmetic: the figure and therefore its sign are the
 *  server's (AD-9), and parsing the string once to ask "below, above or at
 *  zero" computes nothing a reader sees. Zero is its own answer — a case that
 *  has earned nothing is neither a gain nor a loss, and toning it green told
 *  the reader an uncosted case was profitable. */
export type ProfitSign = 'gain' | 'loss' | 'zero'

export function profitSign(amount: string | undefined): ProfitSign | undefined {
  if (amount === undefined || amount === '') return undefined
  const n = Number(amount)
  if (!Number.isFinite(n)) return undefined
  return n > 0 ? 'gain' : n < 0 ? 'loss' : 'zero'
}
